import { css } from '@mui/material/styles';
export const chipComponentOverrides = {
    MuiChip: {
        defaultProps: {
            color: 'default',
            size: 'medium',
            variant: 'outlined'
        },
        styleOverrides: {
            root: ({ theme }) => css `
                height: 2.25rem;
                background-color: ${theme.tokens.FuelColorBackgroundActionDefaultBase};
                border: 1px solid ${theme.tokens.FuelColorGray400};
                padding-block: ${theme.tokens.FuelSpacing2};
                padding-inline: 0.75rem;
                border-radius: ${theme.tokens.FuelBorderRadiusFull};
                color: ${theme.tokens.FuelColorTextSecondary};

                & .MuiChip-label {
                    font-size: ${theme.tokens.FuelFontSizeSm};
                    font-weight: ${theme.tokens.FuelFontWeightSemibold};
                    line-height: ${theme.tokens.FuelLineHeightSm};
                    padding: 0;
                }

                & .MuiChip-icon {
                    fill: ${theme.tokens.FuelColorGray800};
                    height: 1.25rem;
                    margin: 0px;
                    margin-inline-end: ${theme.tokens.FuelSpacing1};
                    margin-inline-start: -${theme.tokens.FuelSpacing1};
                    width: 1.25rem;
                }

                &:hover {
                    background-color: ${theme.tokens.FuelColorBackgroundActionDefaultHovered};
                }

                &:focus-visible {
                    background-color: ${theme.tokens.FuelColorBackgroundActionDefaultBase};
                    outline: 2px solid ${theme.tokens.FuelColorBlack};
                    outline-offset: 2px;
                }

                &:active {
                    box-shadow: none;
                    background-color: ${theme.tokens.FuelColorBackgroundActionDefaultPressed};
                }

                /* --- Select Chip --- */
                &[role='combobox'] {
                    & .MuiChip-label {
                        display: inline-flex;
                        gap: ${theme.tokens.FuelSpacing1};

                        &::after {
                            display: inline-block;
                            margin-inline-end: -${theme.tokens.FuelSpacing1};
                            height: 1.25rem;
                            width: 1.25rem;
                            content: '';
                            background-position: center;
                            background-image: url('data:image/svg+xml;utf-8,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="1.25rem" viewBox="0 0 24 24" width="1.25rem"><rect fill="none" height="1.25rem" width="1.25rem"/><path fill="${theme.tokens.FuelColorGray800}" d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/></svg>`)}');
                        }
                    }
                }
                &[role='combobox'][aria-expanded='true'] {
                    & .MuiChip-label:after {
                        background-image: url('data:image/svg+xml;utf-8,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="1.25rem" viewBox="0 0 24 24" width="1.25rem"><rect fill="none" height="1.25rem" width="1.25rem"/><path fill="${theme.tokens.FuelColorGray800}" d="M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z"/></svg>`)}');
                    }
                }
                &.FuelChip-itemsSelected {
                    background-color: ${theme.tokens.FuelChipColorBackgroundSelected};
                    border: 1px solid ${theme.tokens.FuelChipColorBackgroundSelected};

                    & .MuiChip-label {
                        color: ${theme.tokens.FuelColorWhite};

                        & svg {
                            fill: ${theme.tokens.FuelColorWhite};
                            height: 1.25rem;
                            margin: 0px;
                            width: 1.25rem;
                        }

                        & span {
                            color: ${theme.tokens.FuelColorWhite};
                        }

                        &:after {
                            background-image: url('data:image/svg+xml;utf-8,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="1.25rem" viewBox="0 0 24 24" width="1.25rem"><rect fill="none" height="1.25rem" width="1.25rem"/><path fill="${theme.tokens.FuelColorWhite}" d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/></svg>`)}');
                        }
                    }

                    &[aria-expanded='true'] .MuiChip-label:after {
                        background-image: url('data:image/svg+xml;utf-8,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="1.25rem" viewBox="0 0 24 24" width="1.25rem"><rect fill="none" height="1.25rem" width="1.25rem"/><path fill="${theme.tokens.FuelColorWhite}" d="M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z"/></svg>`)}');
                    }
                    &:hover {
                        background-color: ${theme.tokens.FuelChipColorBackgroundSelected};
                        border: 1px solid ${theme.tokens.FuelChipColorBackgroundSelected};
                    }
                    &.MuiChip-clickable:active {
                        background-color: ${theme.tokens.FuelChipColorBackgroundSelected};
                    }

                }

                /* --- Dismissible Chip --- */
                &.MuiChip-deletable {
                    border: 1px solid ${theme.tokens.FuelChipColorBackgroundSelected};
                    background-color: ${theme.tokens.FuelColorBackgroundActionTertiaryHovered};
                    margin-bottom: ${theme.tokens.FuelSpacing2};

                    &:not(:last-child) {
                        margin-right: ${theme.tokens.FuelSpacing2};;
                    }

                    & .MuiChip-label {
                        margin-inline-end: ${theme.tokens.FuelSpacing1};

                        &:after {
                            background-image: none;
                        }
                    }

                    & .MuiChip-deleteIcon {
                        fill: ${theme.tokens.FuelColorGray800};
                        height: 1.25rem;
                        margin: 0px;
                        margin-inline-end: -${theme.tokens.FuelSpacing1};
                        width: 1.25rem;
                    }

                    &:hover {
                        background-color: ${theme.tokens.FuelColorBackgroundActionDefaultPressed};
                    }

                    &:active {
                        background-color: ${theme.tokens.FuelColorBackgroundActionTertiaryPressed};
                    }
                }

                /* --- Toggle Chip --- */
                &[aria-pressed='true'], &[aria-pressed='mixed'] {
                    background-color: ${theme.tokens.FuelChipColorBackgroundSelected};
                    border: 1px solid ${theme.tokens.FuelChipColorBackgroundSelected};

                    & .MuiChip-label {
                        color: ${theme.tokens.FuelColorWhite};
                    }

                    & .MuiChip-icon {
                        fill: ${theme.tokens.FuelColorWhite};
                    }

                    &:hover {
                        background-color: ${theme.tokens.FuelChipColorBackgroundSelected};
                    }

                    &.MuiChip-clickable:active {
                        background-color: ${theme.tokens.FuelChipColorBackgroundSelected};
                    }
                }

                /* --- Action Chip --- */
                &.MuiChip-clickable {
                    &:active {
                        background-color: ${theme.tokens.FuelColorBackgroundActionTertiaryPressed};
                    }
                }
            `
        }
    }
};
